function App() {
  return (
    <main className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-gray-900 text-white py-8 px-6">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-2xl sm:text-3xl font-semibold">
            Indoor Group Oy:n konkurssipesä
          </h1>
        </div>
      </header>

      {/* Main Content */}
      <article className="max-w-4xl mx-auto px-6 py-12">
        {/* Title Section */}
        <div className="mb-10">
          <p className="text-gray-600 mb-2">11.2.2026</p>
          <h2 className="text-2xl sm:text-3xl font-semibold text-gray-900">
            Tiedote Indoor Group Oy:n konkurssista Indoor Group Oy:n asiakkaille
          </h2>
        </div>

        {/* Main Text */}
        <div className="prose prose-lg max-w-none text-gray-700 space-y-6">
          <p>
            Indoor Group Oy on asetettu konkurssiin Helsingin käräjäoikeuden päätöksellä 10.2.2026 klo 12:00. Konkurssipesän pesänhoitajaksi on määrätty AA Tuomas Penttilä Eversheds Asianajotoimisto Oy:stä. Indoor Group Oy omisti Askon ja Sotkan myymälätoiminnot, verkkokaupat sekä brändin.
          </p>

          <p>
            Konkurssihallinto on käynnistänyt laaja-alaisen haltuunottoprosessin, joka koskee muun muassa Indoor Group Oy:n omaisuutta, järjestelmiä ja prosesseja. Konkurssihallinnon alustavien tietojen mukaan yhtiöllä on konkurssiin asettamishetkellä ollut tuhansia asiakkaita, jotka ovat maksaneet tilaamastaan tuotteesta joko osittain tai kokonaan, mutta eivät ole kuitenkaan saaneet tuotetta.
          </p>

          <p>
            Tilattuja tuotteita koskeva selvitystyö on saatu päätökseen. Mikäli ette ole saaneet yhteydenottoa, tuotteenne ei valitettavasti ole ollut erotettavissa konkurssipesään kuuluvasta omaisuudesta. Konkurssihallinto on noudattanut konkurssilakia ja muuta soveltuvaa lainsäädäntöä arvioidessaan, onko tilattu tuote voitu luovuttaa asiakkaalle vai ei.
          </p>

          <div className="bg-amber-50 border-l-4 border-amber-500 p-4 my-6">
            <p className="text-amber-800">
              Mahdollisten kuljetusyhtiöiden hallussa olevien tuotteiden osalta ilmoitamme, että asiakkaiden tilaukset eivät valitettavasti ole konkurssipesän hallussa tai määräysvallan alaisuudessa, joten konkurssipesä ei voi luovuttaa tilauksia tai myöskään velvoittaa kuljetusyhtiöitä luovuttamaan tilauksia asiakkaille. Kuljetusyhtiöt käyttävät itsenäistä päätösvaltaa hallussaan olevien tavaroiden osalta ja konkurssihallinnon saamien tietojen mukaan vetoavat mahdollisesti asiassa pidätysoikeuteensa.
            </p>
          </div>

          <p>
            Konkurssista johtuen lahjakortit eivät käy maksuvälineenä Sotka tai Asko myymälöissä.
          </p>

          {/* Contact Section */}
          <div className="bg-gray-100 rounded-lg p-6 my-8">
            <h3 className="text-lg font-semibold text-gray-900 mb-3">
              Yhteystiedot
            </h3>
            <p className="text-gray-700 mb-4">
              Indoor Group Oy:n asiakkaat voivat tarvittaessa olla yhteydessä konkurssihallintoon sähköpostitse osoitteeseen:
            </p>
            <a 
              href="mailto:asiakkaat.indoor@eversheds.fi"
              className="text-blue-700 hover:text-blue-900 underline text-lg font-medium"
            >
              asiakkaat.indoor@eversheds.fi
            </a>
            <p className="text-gray-600 mt-3 text-sm">
              Yhteydenottojen valtavasta määrästä johtuen vastausajoissa on huomattavaa viivettä.
            </p>
          </div>

          <p>
            Mikäli ette ole saaneet tilaamaanne tuotetta, jonka olette osin tai kokonaan maksaneet, tai teille on muulla perusteella syntynyt saatavaa Indoor Group Oy:ltä, saatavanne Indoor Group Oy:ltä otetaan automaattisesti huomioon konkurssissa.
          </p>
        </div>

        {/* Footer Signature */}
        <div className="mt-12 pt-8 border-t border-gray-200">
          <p className="text-gray-700 font-medium">
            Kunnioittaen,
          </p>
          <p className="text-gray-700 mt-2">
            INDOOR GROUP OY:N KONKURSSIHALLINTO
          </p>
        </div>
      </article>

      {/* Footer */}
      <footer className="bg-gray-900 text-gray-400 py-6 px-6 mt-auto">
        <div className="max-w-4xl mx-auto text-sm text-center">
          <p>Indoor Group Oy:n konkurssipesä</p>
        </div>
      </footer>
    </main>
  );
}

export default App;
